import React from 'react'
import { Section, GuideHeader, P, UI, Bullets, Callout, Table } from './GuideParts'

export default function BillingGuide() {
  return (
    <div className="space-y-8">
      <GuideHeader
        title="Billing & Analytics"
        intro="How many documents and pages were processed, what that cost, and who and what drove it."
      />

      <Section number={1} title="What Billing & Analytics Shows">
        <P>
          Admins see usage for the organisation. Every figure comes from one record of completed document analyses, so the tiles, the
          plan panel and the cost views always agree with each other.
        </P>
      </Section>

      <Section number={2} title="The Seven Tabs">
        <Table
          head={['Tab', 'Use it to']}
          rows={[
            [<UI key="o">Overview</UI>, 'See the headline numbers for the period.'],
            [<UI key="p">Plan &amp; budget</UI>, 'Check your plan, included pages and budget.'],
            [<UI key="u">Usage</UI>, 'See pages and requests over time, including a spend heatmap in your own time zone.'],
            [<UI key="t">Templates</UI>, 'Compare templates by usage.'],
            [<UI key="pe">People</UI>, 'Compare people by usage.'],
            [<UI key="c">Costs</UI>, 'Explore where the cost comes from.'],
            [<UI key="r">Reports</UI>, 'Download reports.'],
          ]}
        />
        <P>Use the currency toggle to show amounts in GBP (£) or USD ($).</P>
      </Section>

      <Section number={3} title="Pages, Tokens and Cost">
        <P>
          You are charged on pages processed. The page also shows the AI tokens each analysis used. Both are counted once, when an
          analysis completes, so a request that fails does not add to the totals.
        </P>
      </Section>

      <Section number={4} title="Templates and People: Drill-downs">
        <P>
          On the Templates and People tabs, open a row to see a breakdown: “Raised by” for a template and “Templates used” for a person.
          The drawer uses the same period and filters as the table, so it always adds up to the row you clicked.
        </P>
        <Callout kind="info">
          Requests sent from the Outlook add-in or the API are credited to the application’s sign-in, not to the Outlook user.
        </Callout>
      </Section>

      <Section number={5} title="Your Plan and Billing Month">
        <Bullets>
          <li>Billing months follow your purchase date (for Marketplace customers), not the calendar month.</li>
          <li>If the subscription is inactive or suspended, new documents are not processed and you see a banner. Existing results stay readable.</li>
        </Bullets>
      </Section>

      <Section number={6} title="Billing per OpCo">
        <P>
          With OpCos switched on, pages are split by OpCo. Only Super Admins see this split, across every OpCo in the All OpCos view. Moving a request to another OpCo changes the split for the open month only. Past months stay as they were billed.
        </P>
      </Section>
    </div>
  )
}
